export const GET_STRUCTURE_TYPE_DOCUMENT        = 'GET_STRUCTURE_TYPE_DOCUMENT';
export const CHANGE_INPUT_VALUE_GENERAL_CONCEPT = 'CHANGE_INPUT_VALUE_GENERAL_CONCEPT';
export const CHANGE_INPUT_VALUE_CONCEPT         = 'CHANGE_INPUT_VALUE_CONCEPT';
export const SELECTED_CUSTOMER                  = 'SELECTED_CUSTOMER';
export const CHANGE_INPUT_VALUE_NOTES           = 'CHANGE_INPUT_VALUE_NOTES';
export const LIST_DOCUMENTS_BY_TYPE             = 'LIST_DOCUMENTS_BY_TYPE';
export const GET_DOCUMENT_INFORMATION           = 'GET_DOCUMENT_INFORMATION';
export const OPEN_CLOSE_MODAL                   = 'OPEN_CLOSE_MODAL';
export const CHANGE_VALUE_SETTINGS              = 'CHANGE_VALUE_SETTINGS';
export const ACTIVATE_QUANTITY_CONCEPT          = 'ACTIVATE_QUANTITY_CONCEPT';
export const ACTIVATE_EXCHANGE_RATE             = 'ACTIVATE_EXCHANGE_RATE';
export const CHANGE_EXCHANGE_RATE               = 'CHANGE_EXCHANGE_RATE';
export const DISABLED_CONCEPT                   = 'DISABLED_CONCEPT';
export const DISABLED_GENERAL_CONCEPT           = 'DISABLED_GENERAL_CONCEPT';
export const GET_CONCEPTS_LIKE_TREE             = 'GET_CONCEPTS_LIKE_TREE';
export const UPDATE_STATE_CONCEPTS_TREE         = 'UPDATE_STATE_CONCEPTS_TREE';
export const ASIGN_NEW_CONCEPT                  = 'ASIGN_NEW_CONCEPT';
export const CHANGE_VALUE_SPECIAL_INPUT         = 'CHANGE_VALUE_SPECIAL_INPUT';
export const SAVE_NEW_DOCUMENT                  = 'SAVE_NEW_DOCUMENT';
export const MOVE_POSITION_CONCEPT              = 'MOVE_POSITION_CONCEPT';
export const DELETE_DOCUMENT                    = 'DELETE_DOCUMENT';
export const MOVE_POSITION_GENERAL_CONCEPT      = 'MOVE_POSITION_GENERAL_CONCEPT';
export const CHANGE_OPTION_SELECT_ISABI         = 'CHANGE_OPTION_SELECT_ISABI';
export const GET_CONCEPTS_DISCOUNTS             = 'GET_CONCEPTS_DISCOUNTS';
export const CHANGE_STATE_CONCEPTS_DISCOUNTS    = 'CHANGE_STATE_CONCEPTS_DISCOUNTS';
export const ASIGN_NEW_CONCEPT_DISCOUNT         = 'ASIGN_NEW_CONCEPT_DISCOUNT';
export const CHANGE_VALUE_CONCEPT_DISCOUNT      = 'CHANGE_VALUE_CONCEPT_DISCOUNT';
export const CHANGE_POSITION_CONCEPTS_DISCOUNT  = 'CHANGE_POSITION_CONCEPTS_DISCOUNT';
export const OPEN_CLOSE_MODAL_PAYMENT           = 'OPEN_CLOSE_MODAL_PAYMENT';
export const CHANGE_VALUES_INPUTS_PAYMENT       = 'CHANGE_VALUES_INPUTS_PAYMENT';
export const SAVE_PAYMENT_DOCUMENT              = 'SAVE_PAYMENT_DOCUMENT';
export const GET_DETAILS_PAYMENT_DOCUMENT       = 'GET_DETAILS_PAYMENT_DOCUMENT';
export const CONFIRM_PAYMENT_DOCUMENT           = 'CONFIRM_PAYMENT_DOCUMENT';
export const LOAD_INFO_PAYMENT_FORM             = 'LOAD_INFO_PAYMENT_FORM';
export const UPLOAD_PICTURE_PAYMENT             = 'UPLOAD_PICTURE_PAYMENT';
export const DELETE_PAYMENT                     = 'DELETE_PAYMENT';
export const FILTER_DOCUMENTS_BY_RANGE_DATES    = 'FILTER_DOCUMENTS_BY_RANGE_DATES';
export const CHANGE_SEARCH_INPUT_TABLE          = 'CHANGE_SEARCH_INPUT_TABLE';
export const RESET_SEARCH_INPUT_TABLE           = 'RESET_SEARCH_INPUT_TABLE';
export const FILTER_DOCUMENTS_BY_STATUS         = 'FILTER_DOCUMENTS_BY_STATUS';
export const CHANGE_ACCOUNT_BANK                = 'CHANGE_ACCOUNT_BANK';